import { useEffect, useRef } from "react";
import { trackAdvertiser } from "./trackAdvertiser";

export function SponsorBanner({ advertiser, onInquire }) {
  const advertiserId = advertiser?.id;
  const tracked = useRef(false);
  useEffect(() => {
    if (!advertiserId || tracked.current) return;
    tracked.current = true;
    trackAdvertiser(advertiserId, "view");
  }, [advertiserId]);
  if (!advertiser) return null;
  const hasLink = Boolean(advertiser.destination_url);
  const handleClick = () => {
    trackAdvertiser(advertiser.id, "click");
    if (!hasLink) onInquire(advertiser);
  };
  return (
    <div data-testid={`sponsor-banner-${advertiser.id}`} className="rounded-xl border border-[#E7E4DE] bg-white overflow-hidden">
      <div className="flex flex-col sm:flex-row items-stretch">
        {advertiser.image_url && <img src={advertiser.image_url} alt="" className="w-full sm:w-56 h-32 sm:h-auto object-cover flex-shrink-0" />}
        <div className="flex-1 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
          <div className="flex-1 min-w-0">
            <span className="text-[10px] font-mono uppercase tracking-[.14em] text-[#C7A361]">Sponsored{advertiser.service_area ? ` · ${advertiser.service_area}` : ""}</span>
            <p className="font-serif-display text-lg mt-1 text-[#202833]">{advertiser.headline || advertiser.business_name}</p>
            {advertiser.description && <p className="text-sm mt-1 text-[#667085]">{advertiser.description}</p>}
            {advertiser.disclosure_text && <p className="text-[10px] text-[#94A3B8] mt-1.5">{advertiser.disclosure_text}</p>}
          </div>
          {hasLink
            ? <a data-testid={`sponsor-banner-cta-${advertiser.id}`} href={advertiser.destination_url} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="inline-flex items-center justify-center rounded-full bg-[#C7A361] text-[#111820] text-sm font-medium px-5 py-2.5 whitespace-nowrap hover:brightness-95 transition">{advertiser.button_label || "Visit Website"}</a>
            : <button data-testid={`sponsor-banner-cta-${advertiser.id}`} onClick={handleClick} className="inline-flex items-center justify-center rounded-full bg-[#C7A361] text-[#111820] text-sm font-medium px-5 py-2.5 whitespace-nowrap hover:brightness-95 transition">{advertiser.button_label || "Contact Business"}</button>}
        </div>
      </div>
    </div>
  );
}
